export default __webpack_public_path__ + "static/media/da.f0627b96.svg";